import firebase from 'firebase/app';
import 'firebase/auth';
import store from '@/store';

export default firebase.initializeApp({
  apiKey: "AIzaSyCifZ9T4pWzrBi2-67-MiaNH3TGR_VrQPc",
})

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
})
